"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _colors = require("HubStyleTokens/colors");

var _react = require("react");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var UITextToolbarIcon = (0, _styledComponents.default)(_UIIcon.default).attrs({
  size: 14
}).withConfig({
  displayName: "UITextToolbarIcon",
  componentId: "tfcqdu-0"
})(_templateObject(), function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? _colors.BUTTON_DISABLED_TEXT : _colors.HEFFALUMP;
});
UITextToolbarIcon.propTypes = {
  disabled: _react.PropTypes.bool,
  name: _UIIcon.default.propTypes.name
};
var _default = UITextToolbarIcon;
exports.default = _default;
module.exports = exports.default;